module.exports = __webpack_public_path__ + "static/fonts/iconfont.0c63ec1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont.ttf?t=1537345898601
// module id = tZmb
// module chunks = 90